import { render } from "./CatalogHead.vue?vue&type=template&id=d0f86694&scoped=true"
import script from "./CatalogHead.vue?vue&type=script&lang=js"
export * from "./CatalogHead.vue?vue&type=script&lang=js"

import "./CatalogHead.vue?vue&type=style&index=0&id=d0f86694&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f86694"]])

export default __exports__